import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-a3f1585e"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "apply-banner-container"
};
var _hoisted_2 = {
  class: "left-content"
};
var _hoisted_3 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title"
  }, "活动信息", -1);
});
var _hoisted_4 = {
  class: "info-box"
};
var _hoisted_5 = {
  class: "info-list"
};
var _hoisted_6 = {
  class: "info-list-line"
};
var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "key"
  }, "活动编号", -1);
});
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "colon"
  }, "：", -1);
});
var _hoisted_9 = {
  class: "info-list-line"
};
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "key"
  }, "活动名称", -1);
});
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "colon"
  }, "：", -1);
});
var _hoisted_12 = {
  class: "info-list-line"
};
var _hoisted_13 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "key"
  }, "活动项", -1);
});
var _hoisted_14 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "colon"
  }, "：", -1);
});
var _hoisted_15 = {
  class: "info-list-line"
};
var _hoisted_16 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "key"
  }, "活动类型", -1);
});
var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("span", {
    class: "colon"
  }, "：", -1);
});
var _hoisted_18 = {
  class: "right-content"
};
var _hoisted_19 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "title"
  }, "考前须知", -1);
});
var _hoisted_20 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc",
    style: {
      "margin-top": "5px"
    }
  }, " 1、本考试采取网上报名，须在报名期内完成报名并确认报名信息，报名期结束后不可补充报名； ", -1);
});
var _hoisted_21 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc line2"
  }, " 2、考试报名实行实名制，考生报名时应对网上提交的报名信息及相关材料的真实性负责，在考试当天应提交与报名信息一致的证件，如个人填报信息失真、不符合报名要求，则本场考试成绩作废； ", -1);
});
var _hoisted_22 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc"
  }, " 3、考生应按照规定时间准时参考，如考生未按照规定时间参加考试则该项缺考，考试成绩以0分计； ", -1);
});
var _hoisted_23 = {
  class: "btn-box"
};
var _hoisted_24 = /*#__PURE__*/_createTextVNode("查看全部");
var _hoisted_25 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc"
  }, " 1、本考试采取网上报名，须在报名期内完成报名并确认报名信息，报名期结束后不可补充报名； ", -1);
});
var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc mt20"
  }, " 2、考试报名实行实名制，考生报名时应对网上提交的报名信息及相关材料的真实性负责，在考试当天应提交与报名信息一致的证件，如个人填报信息失真、不符合报名要求，则本场考试成绩作废； ", -1);
});
var _hoisted_27 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc mt20"
  }, " 3、考生应按照规定时间准时参考，如考生未按照规定时间参加考试则该项缺考，考试成绩以0分计； ", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_a_col = _resolveComponent("a-col");
  var _component_a_button = _resolveComponent("a-button");
  var _component_a_row = _resolveComponent("a-row");
  var _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_row, {
    gutter: 40
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_a_col, {
        span: 15
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
            class: "cover",
            style: _normalizeStyle("background-image:url(".concat(_ctx.applyService.item.listBanner, ")"))
          }, null, 4), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_hoisted_7, _hoisted_8, _createElementVNode("span", null, _toDisplayString(_ctx.applyService.item.contestInfoId), 1)]), _createElementVNode("div", _hoisted_9, [_hoisted_10, _hoisted_11, _createElementVNode("span", null, _toDisplayString(_ctx.applyService.item.contestInfoName), 1)]), _createElementVNode("div", _hoisted_12, [_hoisted_13, _hoisted_14, _createElementVNode("span", null, _toDisplayString(_ctx.applyService.item.contestItemName), 1)]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _hoisted_17, _createElementVNode("span", null, _toDisplayString(_ctx.applyService.item.activityTypeName), 1)])])])])];
        }),
        _: 1
      }), _createVNode(_component_a_col, {
        span: 9
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_18, [_hoisted_19, _hoisted_20, _hoisted_21, _hoisted_22, _createElementVNode("div", _hoisted_23, [_createVNode(_component_a_button, {
            type: "default",
            shape: "round",
            onClick: _cache[0] || (_cache[0] = function ($event) {
              return _ctx.ruleVisible = true;
            })
          }, {
            default: _withCtx(function () {
              return [_hoisted_24];
            }),
            _: 1
          })])])];
        }),
        _: 1
      })];
    }),
    _: 1
  }), _createVNode(_component_a_modal, {
    visible: _ctx.ruleVisible,
    "onUpdate:visible": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.ruleVisible = $event;
    }),
    title: "考前须知",
    footer: null
  }, {
    default: _withCtx(function () {
      return [_hoisted_25, _hoisted_26, _hoisted_27];
    }),
    _: 1
  }, 8, ["visible"])]);
}